module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"table.drone.serial_no":"S/N : {serial_no}","ticket_table.field.problem_type":"รูปแบบ","ticket_table.field.resolved_result":"ผลประเมิน"}}')
  delete Component.options._Ctor
}
